// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-staticpages-blocks-articlecategoriesblock--wrapper"};